export const FONT_FAMILY = 'ABCDiatypeSemiMono';
